"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Pn;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Pn(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Brands"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "pn",
    d: "M27.964,58.034q-3.45-4.515-7.55-9.691c-2.84-3.313-7.889-9.941-7.889-9.941C16.154,33.2,21.361,35.72,23.1,36.824,37.56,47.515,40.271,64.462,27.964,58.034Zm21.326.881C34.9,41.055,24.592,25.289,28.331,16.386A40.151,40.151,0,0,0,12.855,35.148c9.008-14.367,33.26,17.846,25.705,24.714-3.8,3.379-9.347-.769-10.5-1.705,13.6,17.813,19.1,27.721,9.4,28.529a10.447,10.447,0,0,1-4.892-1.262A18.832,18.832,0,0,1,30.2,84s19.566,10.414-8.363-23.669C17.926,55.59,11.682,47.153,10.29,45.266A40.409,40.409,0,0,0,10,50,40,40,0,0,0,63,87.827C68.042,82.632,60.683,73.058,49.29,58.915Zm1.42-14.2A157.985,157.985,0,0,1,37.7,33.188c2.855,4.354,6.512,9.021,10.333,13.893,15.131,19.327,24.821,31.477,21,38.111a40.165,40.165,0,0,0,9.826-7.5C81.347,69.75,70.816,61.009,50.71,44.714Zm-2.2-34.676c-2.394,3.53,3.559,10.914,6.307,14.321,6.154,7.732,13.1,14.832,19.092,22.722a74.135,74.135,0,0,1,7.574,12.15c2.289,5.021,2.911,8.791,2.56,11.775A40,40,0,0,0,50,10C49.5,10,49,10.019,48.506,10.038ZM54.339,39.98C61.791,45.8,68.008,50.84,72.754,55.306a179.94,179.94,0,0,0-12.419-16.43C50.5,27.258,41.194,15.553,44.534,10.381a39.69,39.69,0,0,0-10.58,2.978A9.357,9.357,0,0,0,32.705,15.5C31.528,22.031,42.323,30.53,54.339,39.98Z"
  })));
}